/**
 * Created by Administrador on 11/11/2016.
 */
(function(){
    'use strict';

    var numberMax = {
        template: '',
        controller: numberMaxController,
        controllerAs: 'vm',
        bindings: {
            max: '=',
            errorKey: "@",
            formName: '<'
        }
    };

    angular
        .module('completeAir')
        .component('numberMax', numberMax);

    function numberMaxController(){
        var vm = this;

        vm.$onInit = function () {
            vm.ngModelCtrl = vm.formName;
        }

        vm.$postLink = function() {
            var maxValidator = function (value) {
                var max = vm.max || Infinity;
                if (value) {
                    value = value.replace(/[^0-9]/g, '');
                }
                if (!isEmpty(value) && value > max) {
                    vm.ngModelCtrl.$setValidity(vm.errorKey, false);
                    return undefined;
                } else {
                    vm.ngModelCtrl.$setValidity(vm.errorKey, true);
                    return value;
                }
            };

            vm.ngModelCtrl.$parsers.push(maxValidator);
            vm.ngModelCtrl.$formatters.push(maxValidator);
        }
    }

})();
